import React from 'react';
import ClientPage from '../../@common/hoc/ClientPage/index';
import asyncComponent from '../../@common/utility/asyncComponent';

const ReflectDetail = asyncComponent(
  () => import('../../modules/clients/ReflectRequest/ReflectionDetail'),
  true,
);
export default ClientPage(() => <ReflectDetail />);
